import { ChartConfig } from "@/components/ui/Chart";

export const chartConfig = {
  inCommunity: {
    label: "In Community",
    legend: "Students in Community",
    color: "var(--bar-chart-light)",
  },
  notInCommunity: {
    label: "Not in Community",
    legend: "Students not in Community",
    color: "var(--bar-chart-dark)",
  },
} satisfies ChartConfig & Record<string, { legend: string }>;
